import { TemplateHeaderPreview } from '../../../components/main/options/model/types'
import { BASE_SERVICE_URL } from '../../../lib/constants'
import newGet from '../../methods/get'

export async function asyncUpload(file: File): Promise<TemplateHeaderPreview> {
    const data = new FormData()
    data.append('file', file)

    return (await fetch(BASE_SERVICE_URL + '/upload', {
        method: 'POST',
        body: data,
        credentials: 'same-origin'
    }).then(response => {
        if (response.ok) {
            return response.json()
        } else {
            throw new Error(response.statusText, { cause: response })
        }
    })) as TemplateHeaderPreview
}

export async function asyncGetPreview(uid: string): Promise<TemplateHeaderPreview> {
    return (await newGet(uid).then(response => {
        if (response.ok) {
            return response.json()
        } else {
            throw new Error(response.statusText, { cause: response })
        }
    })) as TemplateHeaderPreview
}
